// extracted by mini-css-extract-plugin
export default {"time":"AppointmentTime_time__iif9L"};